import { defineComponent as _defineComponent } from 'vue'
import { type DefineComponent, computed, useSlots, resolveComponent } from 'vue'

import { tableField } from './utils'
import VueTable from './VueTable.vue'
import Ordering from './VueTableOrdering.vue'
import VueOrderingController from '@/components/ui/VueOrderingController'

interface Props {
    ordering: Record<string, string>
    orderableFields: string[]
    multiOrderable?: boolean
    // tableComponent?: DefineComponent
    // orderingControllerComponent?: DefineComponent
    // orderingComponent?: DefineComponent
  }


const __default__ = {
  name: 'vue-orderable-table',
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ordering: {},
    orderableFields: {},
    multiOrderable: { type: Boolean }
  },
  emits: ['update:ordering'],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const emit = __emit

const slots = useSlots

const slotKeys = computed(() => {
  const EXCLUDED_SLOT_KEYS = {
    'head-cell': !!(
      props.orderableFields &&
      props.orderableFields.length
    ),
  }

  return Object.keys(slots).filter((x) => !EXCLUDED_SLOT_KEYS[x])
})

const __returned__ = { props, emit, slots, slotKeys, computed, useSlots, resolveComponent, get tableField() { return tableField }, VueTable, Ordering, get VueOrderingController() { return VueOrderingController } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})